import {requestHelpers} from '../../../../../helpers';

export const actions = {
    GET_CUSTOM_URL: "GET_CUSTOM_URL",
    SET_CUSTOM_URL: "SET_CUSTOM_URL",
    GET_CUSTOM_URL_ERROR: "GET_CUSTOM_URL_ERROR",
};

export const getCustomUrl = ( personId, networkId ) => {
    return dispatch => {
        dispatch( {
                type: actions.GET_CUSTOM_URL,
                urlIsFetching: true,
                urlIsError: false,
            });
            requestHelpers
                .authenticatedGetRequest( `/people/${ personId }/custom-url` )
                .then( response => {
                  
                  const newData = response.data[0];

                    if( typeof newData.custom_url !== 'undefined' ) {
                        return dispatch( {
                            type: actions.SET_CUSTOM_URL,
                            networkId,
                            1: `https://www.nonexecutivedirectors.com/profiles/${newData.custom_url}/${newData.person_id}`,
                            2: `https://www.theconsultanthub.com/profiles/${newData.custom_url}/${newData.person_id}`,
                            3: `https://www.financedirectornetwork.com/profiles/${newData.custom_url}/${newData.person_id}`,
                            4: `https://womendirectors.com/profiles/${newData.custom_url}/${newData.person_id}`,
                            5: `https://www.investordirector.com/profiles/${newData.custom_url}/${newData.person_id}`,
                        } );
                    } else {
                        return dispatch( {
                            type: actions.SET_CUSTOM_URL,
                            networkId,
                            1: `https://www.nonexecutivedirectors.com/profiles/${newData.url}/${newData.person_id}`,
                            2: `https://www.theconsultanthub.com/profiles/${newData.url}/${newData.person_id}`,
                            3: `https://www.financedirectornetwork.com/profiles/${newData.url}/${newData.person_id}`,
                            4: `https://womendirectors.com/profiles/${newData.url}/${newData.person_id}`,
                            5: `https://www.investordirector.com/profiles/${newData.url}/${newData.person_id}`,
                        } );
                    }
                } )
                .catch( ( error ) => {
                return dispatch( {
                    type: actions.GET_CUSTOM_URL_ERROR,
                    isLoading: false,
                    isError: true,
                    error,
                })
            })
        };
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/url.js